import { Layout } from 'react-grid-layout'
import React from 'react'
import { TrialStatus, useTrial } from '@/components/TrialSection/TrialSection.hooks'

const LayoutsLocalStorageKey = 'layouts'

const getDefaultLayouts = () => {
  try {
    const item = localStorage.getItem(LayoutsLocalStorageKey) ?? ''
    return JSON.parse(item)
  } catch (error) {
    console.error(error)
  }

  return {
    lg: [
      { i: 'editor', x: 0, y: 0, w: 9, h: 12 },
      { i: 'payload', x: 9, y: 0, w: 3, h: 6 },
      { i: 'results', x: 9, y: 20, w: 3, h: 6 },
    ],
  }
}

export const useGridLayout = () => {
  const [layouts, setLayouts] = React.useState<Record<string, Layout[]>>(getDefaultLayouts())

  const handleLayoutsChange = React.useCallback((value: Record<string, Layout[]>) => {
    localStorage.setItem(LayoutsLocalStorageKey, JSON.stringify(value))
    setLayouts(value)
  }, [])

  return [layouts, handleLayoutsChange] as const
}

export const useGridRowHeight = () => {
  const [, status] = useTrial()
  const calculateRowHeight = (height: number) => {
    const trialBannerHeight = status === TrialStatus.Valid ? 0 : 56
    return Math.floor((height - 172 - trialBannerHeight) / 12)
  }

  const [rowHeight, setRowHeight] = React.useState(calculateRowHeight(window.innerHeight))

  React.useEffect(() => {
    const handleResize = () => {
      setRowHeight(calculateRowHeight(window.innerHeight))
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return rowHeight
}

export const useGridIsSelectDisabled = () => {
  const [isSelectDisabled, setIsSelectDisabled] = React.useState(false)

  const disabledSelect = () => setIsSelectDisabled(true)
  const enableSelect = () => setIsSelectDisabled(false)

  return {
    isSelectDisabled,
    onDragStart: disabledSelect,
    onDragStop: enableSelect,
    onResizeStart: disabledSelect,
    onResizeStop: enableSelect,
  }
}

export const useGridParams = () => {
  const cols = { lg: 12 }
  const breakpoints = { lg: 1200 }
  const rowHeight = useGridRowHeight()

  return {
    cols,
    breakpoints,
    rowHeight,
  }
}
